import React, { useEffect, useState } from 'react';
import './App.css';

// Импорт компонентов
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import AdvantagesSection from './components/AdvantagesSection';
import PortfolioSection from './components/PortfolioSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPage from "./components/PrivacyPage";

function MainPage() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }

      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animated');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
      <>
        <Header scrollToSection={scrollToSection} />
        <main>
          <HeroSection scrollToSection={scrollToSection} />
          <AboutSection />
          <ServicesSection scrollToSection={scrollToSection} />
          <AdvantagesSection />
          <PortfolioSection />
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer scrollToSection={scrollToSection} />
        <ScrollToTop showScrollTop={showScrollTop} />
      </>
  );
}

function App() {
  // Простая проверка: если в URL есть /privacy — показываем PrivacyPage
  const isPrivacyPage = window.location.pathname === '/privacy';

  if (isPrivacyPage) {
    return (
        <div className="App">
          <PrivacyPage />
        </div>
    );
  }

  return (
      <div className="App">
        <MainPage />
      </div>
  );
}

export default App;